import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export const promotionsAPI = {
  getAll: () => api.get('/promotions'),
  getById: (id) => api.get(`/promotions/${id}`),
  create: (data) => api.post('/promotions', data),
  update: (id, data) => api.put(`/promotions/${id}`, data),
  delete: (id) => api.delete(`/promotions/${id}`),
};

export const leadsAPI = {
  create: (data) => api.post('/leads', data),
  getAll: () => api.get('/leads'),
};
